import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { Transition } from '../../../components/Transition';

interface IProps {
  toggle: boolean;
  publicKey: string;
  onClose: () => void;
}

const KeyViewDialog: React.FC<IProps> = ({ toggle, publicKey, onClose }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(publicKey);
    } catch (error) {
      return;
    }
  };

  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      onClose={onClose}
    >
      <DialogTitle>Key id</DialogTitle>
      <DialogContent dividers>
        <TextField
          label='Key id'
          fullWidth
          value={publicKey}
          InputProps={{ readOnly: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={copy}>Copy key id</Button>
        <Button
          variant='contained'
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default KeyViewDialog;
